<template>
    <div>
        <div class="row text-center">
            <div class="col-lg-3 col-12 mt-2 d-inline-block">
                <div class="input-group">
                    <div class="input-group-prepend">
                        <span class="input-group-text">کاربر :</span>
                    </div>
                    <vs-select :data="persons" :mode="'create'"
                               :header="{multiple: false, label: 'name'}"
                               @onChange="onPersonChange"></vs-select>
                </div>
            </div>
            <div class="col-lg-2 col-12 mt-2 d-inline-block">
                <div class="input-group">
                    <div class="input-group-prepend">
                        <span class="input-group-text">وضعیت :</span>
                    </div>
                    <vs-select :data="enVoucherStatus" :mode="'create'"
                               :header="{multiple: false, label: 'title'}"
                               @onChange="onVoucherStatusChange"></vs-select>
                </div>
            </div>
            <div class="col-lg-3 col-12 mt-2 d-inline-block">
                <div class="input-group">
                    <div class="input-group-prepend">
                        <span class="input-group-text">نام مشتری :</span>
                    </div>
                    <vs-select :data="providers" :mode="'create'"
                               :header="{multiple: false, label: 'outSourceName'}"
                               @onChange="onChange"></vs-select>
                </div>
            </div>
            <div class="col-lg-2 col-12 mt-2">
                <div class="input-group mb-2">
                    <div class="input-group-prepend" @click="toggleStartDatePicker">
                        <div class="input-group-text"><span>از تاریخ :</span></div>
                    </div>
                    <date-picker type="date" :auto-submit="true" format="jYYYY-jMM-jDD" @input="onStartDatePicked"
                                 ref="datePickerStart" style="flex: 1">
                        <slot>
                            <input v-model="startDatePersian" class="form-control date-input" readonly="true"
                                   @click="toggleStartDatePicker">
                            <button class="close reset-date" @click="resetStartDate">×</button>
                        </slot>
                    </date-picker>
                </div>
            </div>
            <div class="col-lg-2 col-12 mt-2">
                <div class="input-group mb-2">
                    <div class="input-group-prepend" @click="toggleEndDatePicker">
                        <div class="input-group-text"><span>تا تاریخ :</span></div>
                    </div>
                    <date-picker type="date" :auto-submit="true" :disable="startDatePersian" format="jYYYY-jMM-jDD"
                                 @input="onEndDatePicked"
                                 ref="datePickerEnd" style="flex: 1;">
                        <slot>
                            <input v-model="endDatePersian" class="form-control date-input" readonly="true"
                                   @click="toggleEndDatePicker">
                            <button class="close reset-date" @click="resetEndDate">×</button>
                        </slot>
                    </date-picker>
                </div>
            </div>
            <div class="col-lg-12 col-md-5 col-12 m-2">
                <div class="input-group">
                    <div class="input-group-prepend">
                    <span class="input-group-text">
                        <i class="fa fa-search"></i>
                    </span>
                    </div>
                    <input type="text" class="form-control" placeholder="جستجو..." @input="onSearchInput" ref="searchInput"
                           v-model="searchString">
                </div>
            </div>
            <!--<div class="d-inline-block mx-3">-->
            <!--<button class="btn btn-primary" @click="getReport">ثبت</button>-->
            <!--</div>-->
        </div>
        <hr/>
        <div class="row" v-if="listView">
            <div class="col-lg-8 offset-lg-2" v-for="(item, index) in vouchers">
                <div class="card list" @click="onCardClicked($event, index)">
                    <div class="row">
                        <div class="col-md-3">
                            <strong>شماره سند: </strong>
                            <span>{{item.voucherNumber}}</span>
                        </div>
                        <div class="col-md-6">
                            <strong>کاربر: </strong>
                            <span>{{item.userFullName}}|{{item.userPost}}</span>
                        </div>
                        <div class="col-md-3">
                            <strong>مبلغ: </strong>
                            <span class="text-success">{{(item.price).toLocaleString()}}</span>
                        </div>
                        <div class="col-md-3">
                            <strong>تعداد محصولات: </strong>
                            <span>{{item.productCount}}</span>
                        </div>
                        <div class="col-md-3">
                            <strong>تاریخ سند: </strong>
                            <span>{{item.voucherDate}}</span>
                        </div>
                        <div class="col-md-3">
                            <strong>مشتری: </strong>
                            <span>{{item.receiveOutSourceName}}</span>
                        </div>
                        <div class="col-md-3">
                            <strong>وضعیت: </strong>
                            <span>{{item.refrenceName}}</span>
                        </div>
                        <!--<div class="col-md-3">-->
                        <!--<strong>مبلغ: </strong>-->
                        <!--<span class="text-success">{{(item.price).toLocaleString()}}</span>-->
                        <!--</div>-->
                        <!--<div class="col-md-3">-->
                        <!--<strong>شماره سند: </strong>-->
                        <!--<span>{{item.voucherNumber}}</span>-->
                        <!--</div>-->
                        <!--<div class="col-md-3">-->
                        <!--<strong>وضعیت: </strong>-->
                        <!--<span>{{item.refrenceName}}</span>-->
                        <!--</div>-->
                        <!--<div class="col-md-6">-->
                        <!--<strong>کاربر: </strong>-->
                        <!--<span>{{item.userFullName}}|{{item.userPost}}</span>-->
                        <!--</div>-->
                        <!--<div class="col-md-3">-->
                        <!--<strong>نام مشتری: </strong>-->
                        <!--<span>{{item.receiveOutSourceName}}</span>-->
                        <!--</div>-->
                        <!--<div class="col-md-3">-->
                        <!--<strong>تعداد محصولات: </strong>-->
                        <!--<span>{{item.productCount}}</span>-->
                        <!--</div>-->
                        <!--<div class="col-md-3">-->
                        <!--<strong>تاریخ سند: </strong>-->
                        <!--<span>{{item.voucherDate}}</span>-->
                        <!--</div>-->
                    </div>
                </div>
            </div>
        </div>
        <div class="row" v-else>
            <div class="col-lg-3 col-sm-6 product-container" v-for="(item, index) in vouchers">
                <div :class="{active: item.unitVal > 0}" class="card temp-voucher mt-2 mb-2"
                     @click="onCardClicked($event, index)">
                    <div class="card-body">
                        <div class="row p-2">
                            <div class="col-12 text-center">
                                <div class="text-success">
                                    <h5 class="d-inline">مبلغ: </h5>
                                    <h5 class="d-inline">{{(item.price).toLocaleString()}}</h5>
                                </div>
                            </div>
                            <div class="col-12">
                                <span>شماره سند: </span>
                                <span>{{item.voucherNumber}}</span>
                                <br>
                                <span>وضعیت: </span>
                                <span>{{item.refrenceName}}</span>
                                <br>
                                <span>کاربر: </span>
                                <span>{{item.userFullName}}|{{item.userPost}}</span>
                                <br>
                                <span>نام مشتری: </span>
                                <span>{{item.receiveOutSourceName}}</span>
                                <br>
                                <span>توضیحات: </span>
                                <span>{{item.description}}</span>
                                <br>
                                <span>تعداد محصولات: </span>
                                <span>{{item.productCount}}</span>
                                <br>
                                <span>تاریخ سند: </span>
                                <span>{{item.voucherDate}}</span>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <div class="row">
            <div v-if="vouchers !== undefined && vouchers.length < 1" class="col-lg-12 text-center mt-5 mb-3">
                <h3 class="no-item-alert">گزارشی یافت نشد!</h3>
            </div>
            <div v-if="vouchers.length < dataCount" class="col-lg-12 text-center my-3">
                <button class="btn btn-success" @click="getVouchers">نمایش اسناد بیشتر
                    ({{vouchers.length}}/{{dataCount}})
                </button>
                <div class="col-2 offset-5 my-2">
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <span class="input-group-text">تعداد نمایش</span>
                        </div>
                        <input class="form-control" type="text" @change="changePageSize" v-model="queryParams.pageSize">
                    </div>
                </div>
            </div>
            <div class="col-lg-12">
                <div class="sk-circle" id="loading">
                    <div class="sk-circle1 sk-child"></div>
                    <div class="sk-circle2 sk-child"></div>
                    <div class="sk-circle3 sk-child"></div>
                    <div class="sk-circle4 sk-child"></div>
                    <div class="sk-circle5 sk-child"></div>
                    <div class="sk-circle6 sk-child"></div>
                    <div class="sk-circle7 sk-child"></div>
                    <div class="sk-circle8 sk-child"></div>
                    <div class="sk-circle9 sk-child"></div>
                    <div class="sk-circle10 sk-child"></div>
                    <div class="sk-circle11 sk-child"></div>
                    <div class="sk-circle12 sk-child"></div>
                </div>
            </div>
            <div class="modal fade" id="voucherData" tabindex="-1" role="dialog" aria-labelledby="voucherTitle"
                 aria-hidden="true">
                <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-header bg-warning-grad glow-warning">
                            <h5 class="modal-title text-white" id="voucherTitle">محصولات فاکتور</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body" id="printMe">
                            <div class="table-responsive">
                                <!--<h3 class="text-center">فروشگاه-->
                                <!--{{companyName}}</h3>-->
                                <!--<h5 class="text-center">فاکتور فروش</h5>-->
                                <!--<h6 class="text-center" >-->
                                <!--خریدار :-->
                                <!--{{voucher.voucher !== undefined ?  voucher.voucher.receiveOutSourceName : ''}}-->
                                <!--تاریخ :-->
                                <!--{{ voucher.voucher !== undefined ?  voucher.voucher.persianDate : '' }}-->
                                <!--سند شماره :-->
                                <!--{{ voucher.voucher !== undefined ?  voucher.voucher.voucherNumber : ''}}-->
                                <!--کاربر :-->
                                <!--{{ voucher.voucher !== undefined ?  voucher.voucher.userFullName : ''}}-->
                                <!--</h6>-->

                                <table class="table table-hover table-striped">
                                    <thead>
                                    <tr>
                                        <th class=" text-nowrap">{{companyName}}</th>
                                        <th class="text-center text-nowrap">فاکتور فروش</th>
                                        <th class="text-center text-nowrap"><img class="view-image-print"
                                                                                 :src="logoAddress!= null ? logoAddress : 'https://panel.dbaccount.ir/img/buy.png'"/></th>
                                    </tr>
                                    <tr>
                                        <th class=" text-nowrap">{{ voucher.voucher !== undefined ? voucher.voucher.persianDate : '' }}</th>
                                        <th class="text-center text-nowrap">شماره فاکتور :
                                            {{ voucher.voucher !== undefined ? voucher.voucher.voucherNumber : ''}}
                                        </th>
                                        <th class="text-center text-nowrap">کاربر
                                            {{ voucher.voucher !== undefined ? voucher.voucher.userFullName : ''}}
                                        </th>
                                    </tr>
                                    <tr>
                                        <th class=" text-nowrap">خریدار:
                                            {{voucher.voucher !== undefined ? voucher.voucher.receiveOutSourceName : ''}}
                                        </th>
                                        <th class="text-center text-nowrap">شماره تماس:
                                            {{voucher.voucher !== undefined ? voucher.voucher.phoneNumber : ''}}
                                        </th>
                                        <th class="text-center text-nowrap">کد ملی:
                                            {{voucher.voucher !== undefined ? voucher.voucher.branchCode : ''}}
                                        </th>
                                    </tr>
                                    <tr>
                                        <th class=" text-nowrap" colspan="3">آدرس:
                                            {{voucher.voucher !== undefined ? voucher.voucher.address : ''}}
                                        </th>

                                    </tr>
                                    </thead>
                                </table>


                                <table class="table table-hover table-striped">
                                    <thead>
                                    <tr>
                                        <th class=" text-nowrap">نام محصول</th>
                                        <!--<th class="text-center text-nowrap">قیمت خرید</th>-->
                                        <th class="text-center text-nowrap">تعداد</th>
                                        <th class="text-center text-nowrap">فی فروش</th>
                                        <th class="text-center  text-nowrap">تخفیف</th>
                                        <th class="text-center  text-nowrap">مالیات</th>
                                        <th class="text-center text-nowrap">جمع</th>
                                    </tr>
                                    </thead>
                                    <tbody v-if="voucher !== undefined">
                                    <tr v-for="(item,index) in voucher.products">
                                        <!--<td class="product-remove-button"><a class="text-danger" @click="onRemoveProductClicked(index)"><i class="fa fa-close"></i></a></td>-->
                                        <td>{{item.productName}}</td>
                                        <!--<td class="text-center">-->
                                        <!--{{item.price.toLocaleString()}}-->
                                        <!--</td>-->
                                        <td class="text-center">
                                            {{item.unitVal}}
                                        </td>
                                        <td class="text-center">
                                            {{item.salesPrice.toLocaleString()}}
                                        </td>
                                        <td class="text-center">
                                            {{item.discount.toLocaleString()}}
                                        </td>
                                        <td class="text-center">
                                            {{item.taxPrice.toLocaleString()}}
                                        </td>
                                        <td class="text-center">
                                            {{(item.unitVal * (item.salesPrice- item.discount+item.taxPrice) ).toLocaleString()}}
                                        </td>
                                    </tr>
                                    <!--<tr>-->
                                        <!--<td class="text-left"><b>جمع</b></td>-->
                                        <!--<td class="text-center"><b>{{overallAmount.toLocaleString()}}</b></td>-->
                                        <!--<td class="text-center" v-if="voucher.voucher !== undefined">-->
                                            <!--<b>{{(voucher.voucher.price+voucher.voucher.discount + voucher.voucher.totalDiscount).toLocaleString()}}</b>-->
                                        <!--</td>-->
                                        <!--<td class="text-center" v-if="voucher.voucher !== undefined">-->
                                            <!--<b>{{(voucher.voucher.totalDiscount).toLocaleString()}}</b>-->
                                        <!--</td>-->
                                        <!--<td class="text-center" v-if="voucher.voucher !== undefined">-->
                                            <!--<b>{{(voucher.voucher.price+voucher.voucher.discount).toLocaleString()}}</b>-->
                                        <!--</td>-->
                                    <!--</tr>-->
                                    </tbody>
                                </table>
                                <h4 class="text-center mt-5"
                                    v-if=" voucher.products !== undefined && voucher.products.length < 1">محصولی ثبت
                                    نشده است!</h4>
                            </div>
                            <div class="input-group mt-2">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">تخفیف فاکتور</span>
                                </div>
                                <span v-if="voucher.voucher !== undefined" class="form-control text-right">{{voucher.voucher.discount.toLocaleString()}}</span>
                            </div>
                            <div class="input-group mt-2">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">مالیات فاکتور</span>
                                </div>
                                <span class="form-control text-right">{{voucher.voucher !== undefined  && voucher.voucher.taxPrice !== undefined? voucher.voucher.taxPrice.toLocaleString() : 0}}</span>
                            </div>
                            <div class="input-group mt-2">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">توضیحات</span>
                                </div>
                                <span v-if="voucher.voucher !== undefined" class="form-control text-right">{{voucher.voucher.description}}</span>
                            </div>
                            <div class="text-center w-100 p-1 text-bold">
                                <span>قابل پرداخت : </span>
                                <span v-if="voucher.voucher !== undefined">{{(parseInt(voucher.voucher.price)).toLocaleString()}}</span>
                                <span>&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp</span>
                                <span>مانده فاکتور : </span>
                                <span v-if="voucher.voucher !== undefined">{{(parseInt(parseInt(voucher.voucher.price) -  voucher.payments.reduce( (acc, itt) => { return acc += itt.price; }, 0))).toLocaleString()}}</span>
                            </div>
                        </div>
                        <div class="modal-footer d-block">
                            <!--<hr class=" w100"/>-->
                            <h5 class="w-100 text-center" v-if="voucher.payments !== undefined && voucher.payments.length>0">لیست پرداختها</h5>
                            <h5 class="w-100 text-center" v-else>فاکتور پرداخت نشده است</h5>
                            <div class="w-100 " v-if="voucher.payments !== undefined&& voucher.payments.length>0">
                                <table class="table table-hover table-striped">
                                    <thead>
                                    <tr>
                                        <th class=" text-nowrap text-center">مبلغ</th>
                                        <th class=" text-nowrap text-center">تاریخ</th>
                                        <th class="text-center">توضیحات</th>
                                    </tr>
                                    </thead>
                                    <tbody v-if="voucher !== undefined">
                                    <tr v-for="(item,index) in voucher.payments">
                                        <!--<td class="product-remove-button"><a class="text-danger" @click="onRemoveProductClicked(index)"><i class="fa fa-close"></i></a></td>-->
                                        <td>{{item.price.toLocaleString()}}</td>
                                        <td class="text-nowrap">{{item.fdate}}</td>
                                        <td class="text-center">
                                            {{item.code}}
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>


                            <!--<div class="text-right w-100">-->
                            <!--<span>تاریخ سند: </span>-->
                            <!--<span v-if="voucher.voucher !== undefined">{{voucher.voucher.persianDate}}</span>-->
                            <!--</div>-->
                            <div class="text-center w-100 p-1 text-bold">
                                <span>وضعیت فاکتور :</span>
                                <span v-if="voucher.voucher !== undefined">{{voucher.voucher.refrenceName}}</span>
                            </div>
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">تغییر وضعیت :</span>
                                </div>
                                <vs-select :data="enVoucherStatus" :mode="'create'"
                                           :header="{multiple: false, label: 'title'}"
                                           @onChange="onVoucherStatusChange2"></vs-select>
                            </div>
                            <button type="button" class="d-inline-block btn btn-success m-1" @click="onPrintClicked"><i
                                    class="fa fa-print"></i></button>
                            <button class="d-inline-block btn btn-info m-1" title="دانلود خروجی اکسل">
                                <export-excel
                                        :data="excelVoucher"
                                        :fields="excelHeaders"
                                        :name="filename"
                                        :title="exceltitle"
                                        :footer="excelFooter"

                                >

                                    <i class="fa fa-file-excel-o"></i>
                                </export-excel>
                            </button>
                            <button type="button" class="btn btn-secondary mr-1" data-dismiss="modal">بستن</button>
                            <button type="button" class="btn btn-secondary mr-1" @click="onPaymentClicked(voucher)"
                                    v-if="voucher.voucher !== undefined && (parseInt(voucher.voucher.price) -  voucher.payments.reduce( (acc, itt) => { return acc += itt.price; }, 0)) > 0">
                                پرداخت
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import * as $ from 'jquery';
    import BaseService from "../../_framework/api/BaseService";
    import Utils from "../../_framework/utils/Utils";
    import Moment from "moment-jalali";
    import EventBus from "../../_framework/event-bus.js";
    import DatePicker from '../../components/vue-persian-datetime-picker/VuePersianDatetimePicker.vue';
    import VsSelect from "../../_framework/VsSelect"
    import VueHtmlToPaper from 'vue-html-to-paper';
    import Vue from 'vue';
    import excel from 'vue-excel-export'

    Vue.use(excel)

    $(function () {
        var pos1 = 0;
        $(window).scroll(function () {
            var pos2 = $(window).scrollTop();
            if (pos2 > pos1) {
                $(".search-area").addClass("hidden");
            }
            if (pos1 > pos2) {
                $(".search-area").removeClass("hidden");
            }
            pos1 = pos2;
        })
    });

    export default {
        name: 'sell-report',
        components: {
            DatePicker,
            VsSelect,
        },
        data() {
            return {
                printoptions:{
                    name: '_blank',
                    specs: [
                        'fullscreen=yes',
                        'titlebar=yes',
                        'scrollbars=yes'
                    ],
                    styles: [
                        'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
                        'https://unpkg.com/kidlat-css/css/kidlat.css'
                    ],
                    windowTitle: "Vue Html To Paper - Vue mixin for html elements printing."
                },
                filename: "گزارش دریافتها",
                exceltitle:[],
                excelFooter: [],
                excelHeaders: {
                    'نام محصول': 'productName',
                    'تعداد': 'unitVal',
                    'فی فروش': 'salesPrice',
                    'مبلغ قبل از تخفیف': 'tot',
                    'تخفیف': 'discount',
                    'مبلغ بعد از تخفیف': 'totdiscount',
                    'درصد مالیات': 'taxPercent',
                    'مبلغ مالیات': 'taxPrice',
                    'جمع': 'totTax',
                },
                excelVoucher:[],

                logoAddress: "",
                searchString: "",
                persons: [],
                selectedPerson: null,
                vouchers: [],
                voucher: {},
                overallAmount: 0,
                queryParams: {
                    pageSize: 12,
                    pageIndex: 0,
                    type: 1
                },
                otherParams: {
                    pageSize: 1000000,
                    pageIndex: 0,
                    type: 1
                },
                dataCount: 0,

                listView: false,
                fromDate: "",
                fromDateJ: "",
                toDate: "",
                toDateJ: "",
                startDatePersian: "",
                endDatePersian: "",
                providers: [],
                selectedProvider: 0,
                companyName: "",
                enVoucherStatus: [],
                selectetdEnVoucherStatus: {},
            }
        },
        mounted() {

            this.logoAddress = localStorage.getItem("logoAddress");
            this.companyName = localStorage.getItem("companyName");
            this.listView = JSON.parse(localStorage.getItem("listView"));
            EventBus.$on('listView', value => {
                this.listView = value;
            });
            this.getVouchers(-1);
            this.getProviders();
            this.getPersons();
            this.getEnVoucherStatus();
        },
        methods: {
            changePageSize(e) {
                this.getVouchers(-1);
            },
            getPersons() {

                let ids = JSON.parse(localStorage.getItem("company_usersId"));
                let names = JSON.parse(localStorage.getItem("company_usersName"));
                for (let i of ids) {
                    let per = {
                        id: i,
                        name: names[ids.indexOf(i)]
                    };
                    this.persons.push(per);
                }
                // console.log(this.persons)
            },
            onPrintClicked() {
                this.printoptions.windowTitle = "گزارش فروش به " + this.voucher.voucher.receiveOutSourceName +  " شماره فاکتور " + this.voucher.voucher.voucherNumber;
                Vue.use(VueHtmlToPaper,this. printoptions);
                this.$htmlToPaper('printMe');
            },
            getEnVoucherStatus() {

                new BaseService('enum', '/getEnVoucherStatus').getList().then(response => {
                    this.enVoucherStatus = response.data;
                }).catch(error => {
                    // error
                    Utils.handleErrorWithNotification(error.response.data.message, this.$noty);
                });
            },
            getVouchers(page) {
                if (page === -1) {
                    this.queryParams.pageIndex = 0;
                    this.vouchers = [];
                } else {
                    this.queryParams.pageIndex++;
                }
                $("#loading").show();
                new BaseService('reports', '/getvoucherreport').getList(this.queryParams).then(response => {
                    let newItems = response.data.data;
                    this.dataCount = response.data.count;
                    for (let item of newItems) {
                        item.voucherDate = Moment(item.voucherDate, 'YYYY-MM-DD').format('jDD jMMMM jYYYY');
                        for (let s of this.enVoucherStatus) {
                            if (item.refrenceNumber === null) {
                                item.refrenceName = this.enVoucherStatus[0].title;
                            } else if (parseInt(item.refrenceNumber) === s.value) {
                                item.refrenceName = s.title;
                            }
                        }
                    }
                    this.vouchers.push.apply(this.vouchers, newItems);
                    $("#loading").hide();
                }).catch(error => {
                    // error
                    Utils.handleErrorWithNotification(error.message, this.$noty);
                });
            },
            onCardClicked(e, index) {
                this.overallAmount = 0;
                let id = this.vouchers[index].id;
                new BaseService('voucher', `/getproducts/${id}`).getList().then(response => {
                    this.voucher = response.data;
                    for (let item of this.voucher.products) {
                        this.overallAmount += item.unitVal;

                        item.totdiscount =(item.salesPrice - item.discount )* item.unitVal;
                        item.totTax = (item.taxPrice)* item.unitVal;
                        item.tot =(item.salesPrice )* item.unitVal;

                        // 'totdiscount',
                        //     'درصد مالیات': 'taxPercent',
                        //     'قیمت بعد از مالیات': 'totTax',
                        //     'جمع': 'total',

                    }

                    this.excelVoucher =this.voucher.products;
                    this.filename="گزارش فروش سند " +this.voucher.voucher.voucherNumber +" مشتری " +this.voucher.voucher.receiveOutSourceName;
                    this.exceltitle.push("فاکتور فروش");
                    this.exceltitle.push( " شماره فاکتور : " + this.voucher.voucher.voucherNumber +"  تاریخ : " + this.voucher.voucher.persianDate + "   کاربر : " + this.voucher.voucher.userFullName);
                    this.exceltitle.push("مشخصات مشتری");
                    this.exceltitle.push("نام : " + this.voucher.voucher.receiveOutSourceName +"   شماره تماس : " + this.voucher.voucher.phoneNumber);
                    this.exceltitle.push("آدرس : " + this.voucher.voucher.address ?? "");


                    this.excelFooter.push("تخفیف فاکتور : " + this.voucher.voucher.discount.toLocaleString());
                    this.excelFooter.push("مالیات فاکتور : " + this.voucher.voucher.taxPrice.toLocaleString());
                    this.excelFooter.push("قابل پرداخت : " + this.voucher.voucher.price.toLocaleString());
                    this.excelFooter.push("توضیحات : " + this.voucher.voucher.description);

                    if (this.voucher.payments != undefined && this.voucher.payments != null) {
                        for (let i of this.voucher.payments) {
                            i.fdate = Moment(i.check.checkDate, 'YYYY-MM-DD HH:mm').format('jYYYY/jMM/jDD-HH:mm');
                        }
                    }
                    for (let s of this.enVoucherStatus) {
                        if (this.voucher.voucher.refrenceNumber === null) {
                            this.voucher.voucher.refrenceName = this.enVoucherStatus[0].title;
                        } else if (parseInt(this.voucher.voucher.refrenceNumber) === s.value) {
                            this.voucher.voucher.refrenceName = s.title;
                        }
                    }
                    $("#voucherData").modal("show");
                }).catch(error => {
                    Utils.handleErrorWithNotification(error.message, this.$noty);
                })
            },
            getProviders() {
                this.otherParams = {
                    pageSize: 100000,
                    pageIndex: 0,
                    name: "",
                    types: 3
                };
                new BaseService('outsource', '/getlist').getList(this.otherParams).then(response => {
                    this.providers = response.data.data;
                    let allPro = {
                        id: 0,
                        outSourceName: "همه مشتری ها"
                    };
                    this.providers.push(allPro);
                }).catch(error => {
                    // error
                    Utils.handleErrorWithNotification(error.message, this.$noty);
                });


            },
            toggleStartDatePicker() {
                this.$refs.datePickerStart.togglePicker();
            },
            toggleEndDatePicker() {
                this.$refs.datePickerEnd.togglePicker();
            },
            onStartDatePicked(val) {
                this.fromDate = Moment(val, 'jYYYY-jMM-jDD').format('YYYY-MM-DD');
                this.startDatePersian = Moment(val, 'jYYYY-jMM-jDD').format('jDD jMMMM jYYYY');
            },
            onEndDatePicked(val) {
                this.toDate = Moment(val, 'jYYYY-jMM-jDD').format('YYYY-MM-DD');
                this.endDatePersian = Moment(val, 'jYYYY-jMM-jDD').format('jDD jMMMM jYYYY');
                this.getReport();
            },
            resetStartDate() {
                this.fromDate = '';
                this.startDatePersian = '';
            },
            resetEndDate() {
                this.toDate = '';
                this.endDatePersian = '';
            },
            getReport() {
                this.queryParams = {
                    reciveId: this.selectedProvider,
                    from: this.fromDate,
                    to: this.toDate,
                    pageSize: 12,
                    pageIndex: 0,
                    type: 1

                };
                this.getVouchers(-1);
            },
            onChange(val) {
                if (val) {
                    this.selectedProvider = val.id;
                    this.queryParams = {
                        reciveId: this.selectedProvider,
                        pageSize: 12,
                        pageIndex: 0,
                        type: 1
                    };

                } else {
                    this.selectedProvider = null;
                    this.queryParams = {
                        pageSize: 12,
                        pageIndex: 0,
                        type: 1,
                    };

                }
                this.getVouchers(-1);
            },
            onPersonChange(val) {

                if (val) {
                    this.selectedPerson = val;
                    this.queryParams = {
                        reciveId: this.selectedProvider,
                        pageSize: 12,
                        pageIndex: 0,
                        type: 1,
                        userId: val.id
                    };

                } else {
                    this.selectedPerson = null;
                    this.queryParams = {
                        reciveId: this.selectedProvider,
                        pageSize: 12,
                        pageIndex: 0,
                        type: 1,

                    };

                }
                this.getVouchers(-1);
            },
            onVoucherStatusChange(val) {
                if (val) {
                    this.selectetdEnVoucherStatus = val;
                    this.queryParams = {
                        outsourceId: this.selectedProvider,
                        pageSize: 12,
                        pageIndex: 0,
                        type: 1,
                        status: val.value
                    };

                } else {
                    this.selectetdEnVoucherStatus = null;
                    this.queryParams = {
                        outsourceId: this.selectedProvider,
                        pageSize: 12,
                        pageIndex: 0,
                        type: 1

                    };
                }
                this.getVouchers(-1);
            },
            onVoucherStatusChange2(val) {
                console.log(this.voucher)
                console.log(val)
                if (val) {
                    new BaseService('voucher', `/changeStatus/${this.voucher.voucher.id}/${val.value}`).create().then(response => {
                        this.$noty.success("وضعیت با موفقیت به " + val.title + " تغییر کرد");
                        $("#voucherData").modal("hide");
                        this.getVouchers(-1);
                    }).catch(error => {
                        Utils.handleErrorWithNotification(error.response.data.message, this.$noty);
                    })
                }

            },
            onPaymentClicked(item) {
                let remain = parseInt(item.voucher.price) - item.payments.reduce((acc, itt) => {
                    return acc += itt.price;
                }, 0);
                item.voucher.overallPrice = remain;
                item.voucher.overallAmount = 0;
                for (let p of item.products) {
                    item.voucher.overallAmount += p.unitVal;
                }
                if (!isNaN(item.voucher.overallPrice) && !isNaN(item.voucher.overallAmount)) {
                    item.voucher.voucherProductDto = item.products;
                    $("#voucherData").modal("hide");
                    let obj = {
                        name: 'payment',
                        path: '/payment',
                        params: {
                            voucher: item.voucher,
                            type: "sell"
                        }
                    };

                    console.log(obj)
                    this.$router.push(obj);
                } else {
                    this.$noty.warning('قیمت یا تعداد محصولات به درستی وارد نشده است!');
                }
            },
            onSearchInput() {
                if (this.searchString.length > 2) {
                    this.queryParams = {
                        name: this.searchString,
                        pageSize: 12,
                        pageIndex: 0,
                        type: 1
                    };
                } else {
                    this.queryParams = {
                        pageSize: 12,
                        pageIndex: 0,
                        type: 1
                    };
                }
                this.getVouchers(-1);

            },

        },
        beforeRouteLeave(to, from, next) {
            $(window).unbind('scroll');
            if ($("#voucherData").hasClass("show")) {
                $("#voucherData").modal("hide");
                next(false);
            } else {
                next();
            }
        },
    }
</script>